import { render, staticRenderFns } from "./googlePlay.vue?vue&type=template&id=6e45e8a9&"
import script from "./googlePlay.vue?vue&type=script&lang=js&"
export * from "./googlePlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports